import { useMenuModal } from 'contexts/MenuModalContext';
import { ChoiceTransitionDiv } from 'menu/components/MenuModal/ModalBody';

export const SelectedNestedChoiceHeader: React.FC = () => {
  const { breadcrumbs } = useMenuModal();

  if (breadcrumbs.length > 0) {
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    if (lastBreadcrumb.choiceName) {
      return (
        <ChoiceTransitionDiv>
          <h4>{lastBreadcrumb.choiceName}</h4>
          <hr />
        </ChoiceTransitionDiv>
      );
    }
  }

  return null;
};
